import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;

export function initSentry() {
  // Both are injected by the deploy workflow, so local development stays silent.
  if (!SENTRY_DSN || !SENTRY_ENVIRONMENT) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
    ],
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/.*\.api\.getruta\.com/,
      'https://api.getruta.com',
    ],
  });
}
